import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "src/components/Common/TableContainer";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import useToast from "src/components/Common/toast";
import { clearToast } from "src/slices/toast/reducer";

const Users = () => {
  document.title = "Utilizadores - Khozi";
  const navigate = useNavigate();
  const users = useSelector((state: any) => state.users.users || []);
  const { show, ToastComponent } = useToast();
  const action = useSelector((state: any) => state.toast.action);
  const dispatch = useDispatch();
  useEffect(() => {
    if (action === "update-success") {
      show("Sucesso", "Utilizador actualizado com sucesso");
      dispatch(clearToast());
    } else if (action === "delete-success") {
      show("Sucesso", "Utilizador apagado com sucesso");
      dispatch(clearToast());
    } else if (action === "create-success") {
      show("Sucesso", "Utilizador criado com sucesso");
      dispatch(clearToast());
    }
  }, []);

  const handleRowClick = (user: any) => {
    navigate(`/users/${user.id}`);
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Nome",
        accessor: (row: any) => `${row.first_name} ${row.last_name}`,
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Telefone",
        accessor: "profile__telephone",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Função",
        accessor: (row: any) => {
          const roleMap: { [key: string]: string } = {
            AD: "Admin",
            EX: "Executivo",
            OP: "Operador",
          };
          return roleMap[row.profile__role] || "-";
        },
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Status",
        accessor: (row: any) => {
          return row.profile__status === "A" ? "Ativo" : "Inativo";
        },
        disableFilters: true,
        filterable: true,
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {ToastComponent}
          <Breadcrumbs title="Khozi" breadcrumbItem="Utilizadores" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddUserList={true}
                    customPageSize={10}
                    addButtonLabel="Novo Utilizador"
                    className="custom-header-css"
                    handleUserClick={() => {
                      navigate("/users/create");
                    }}
                    handleRowClick={handleRowClick}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Users;
